import React from 'react';
import { Input, Frame, SageClassnames } from '@kajabi/sage-react';
import DeleteResultItemButton from 'common/components/CopyMagic/components/DeleteResultItemButton';
import useEditResultItem from 'common/components/CopyMagic/hooks/useResultEditItem';
import { postTitleSchema } from 'common/components/CopyMagic/shared/validationSchema';

const PostTitleInput = ({ attributePath }: { attributePath: (string | number)[] }) => {
  const { inputName, onChangeHandler, onFocusHandler, onBlurHandler, value, errorMessage } =
    useEditResultItem({ attributePath, validationSchema: postTitleSchema });
  const topLevelAttributePath = attributePath.slice(0, -1);

  return (
    <Frame
      direction={Frame.DIRECTIONS.HORIZONTAL}
      gap={Frame.GAPS.SM}
      align={Frame.ALIGNMENTS.TOP_LEFT}
      width={Frame.WIDTHS.FILL}
      className={SageClassnames.SPACERS.SM_LEFT}
    >
      <Frame align={Frame.ALIGNMENTS.CENTER_SPREAD}>
        <Input
          name={inputName}
          onChange={onChangeHandler}
          onFocus={onFocusHandler}
          onBlur={onBlurHandler}
          value={value}
          label="Lesson"
          message={errorMessage}
          hasError={!!errorMessage.length}
        />
      </Frame>
      <Frame width="32px" className={SageClassnames.SPACERS.XS_TOP}>
        <DeleteResultItemButton
          attributePath={topLevelAttributePath}
          className={`${SageClassnames.SPACERS.LG_TOP}`}
        />
      </Frame>
    </Frame>
  );
};

export default PostTitleInput;
